import { call, put, takeLatest } from 'redux-saga/effects';
import { defaultApi } from '../../utils/axiosApi';
import {
  GET_CHECK_HANDS_DATA,
  getCheckHandsDataSuccess,
  getCheckHandsDataFailure,
} from './checkHandsActions';

// Get check hands data

export function* getCheckHandsData() {
  try {
    const url = 'albait/check-hands/';
    const response = yield defaultApi(url, 'GET', null);
    yield put(getCheckHandsDataSuccess(response));
  } catch (error) {
    yield put(getCheckHandsDataFailure(error.message));
  }
}

// Watcher saga
export function* watchCheckHandsData() {
  yield takeLatest(GET_CHECK_HANDS_DATA, getCheckHandsData);
}

export default watchCheckHandsData;